import { DocumentData, Firestore, QuerySnapshot } from 'firebase/firestore';
import { typeUniqueId } from "../../../../dataObjects/types"
import { FirebaseAppSingleton } from "../../../cloudServices/googleFirebaseServices/FirebaseAppSingleton";
import { IFirestoreAudioLinkRepository_Ext, FirestoreAudioLinkRepository_Ext } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreAudioLinkRepository";


export function getAudioLinksForIds_onSnapshot(ids: Array<typeUniqueId>, callback: (snapshot: QuerySnapshot<DocumentData>) => void): Promise<Array<() => void>> {
  return new Promise<Array<() => void>>(async (resolve, reject) => {
    try {
      // initialize a Firestore object instance
      const firestoreObj: Firestore = FirebaseAppSingleton.firestore;

      const firestoreAudioLinkRepository_Ext: IFirestoreAudioLinkRepository_Ext = new FirestoreAudioLinkRepository_Ext(firestoreObj);

      // fetch the topics for the pertinent channelId
      const unsubscribeCallbacks: Array<() => void> = await firestoreAudioLinkRepository_Ext.getObjectsForIds_onSnapshot(ids, callback);

      resolve(unsubscribeCallbacks);
    }
    catch (error: any) {
      reject(error);
    }
  });
}